import { z } from 'zod';
import { USER_PASSWORD_MIN_LENGTH } from '../constants';
import { phoneSchema, text } from './common';

const emailSchema = z.string().trim().toLowerCase().email().max(254);

export const telegramAuthSchema = z.object({
  initData: z.string().min(1).max(4096),
});
export type TelegramAuthBody = z.infer<typeof telegramAuthSchema>;

export const signupSchema = z.object({
  email: emailSchema,
  password: z.string().min(USER_PASSWORD_MIN_LENGTH).max(128),
  nickname: text(2, 32),
  fullName: text(2, 100),
});
export type SignupBody = z.infer<typeof signupSchema>;

export const verifyEmailSchema = z.object({
  email: emailSchema,
  code: z.string().regex(/^\d{6}$/, 'Code must be 6 digits'),
});
export type VerifyEmailBody = z.infer<typeof verifyEmailSchema>;

export const resendEmailSchema = z.object({ email: emailSchema });
export type ResendEmailBody = z.infer<typeof resendEmailSchema>;

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(128),
  totpCode: z.string().min(6).max(20).optional(),
});
export type LoginBody = z.infer<typeof loginSchema>;

export const otpRequestSchema = z.object({ phone: phoneSchema });
export type OtpRequestBody = z.infer<typeof otpRequestSchema>;

export const otpVerifySchema = z.object({
  phone: phoneSchema,
  code: z.string().regex(/^\d{6}$/, 'Code must be 6 digits'),
});
export type OtpVerifyBody = z.infer<typeof otpVerifySchema>;

export const refreshSchema = z.object({ refreshToken: z.string().min(16).max(256) });
export type RefreshBody = z.infer<typeof refreshSchema>;

export const logoutSchema = refreshSchema;
